import { propsMap } from '@/presentation/interfaces';

export const sizes: propsMap = {
  xxxs: '0.625rem',
  xxs: '0.78125rem',
  xs: '0.9375rem',
  s: '1.0935rem',
  m: '1.25rem',
  l: '1.5625rem',
  xl: '1.75rem',
  xxl: '2.50rem',
};

export const weights: propsMap = {
  regular: '400',
  medium: '500',
  semiBold: '600',
  bold: '700',
};

export const lineHeights: propsMap = {
  xxxs: '0.9375rem',
  xxs: '1.09375rem',
  xs: '1.25rem',
  s: '1.5625rem',
  m: '1.5625rem',
  l: '1.5625rem',
};

export const letterSpacings: propsMap = {
  xxxs: '0.00625rem',
  xxs: '0',
  xs: '0.013125rem',
  s: '0.015625rem',
  m: '0.015625rem',
  l: '0.015625rem',
};
